const getCozyGameIdByGameTokenId = gameTokenId => {
    switch (gameTokenId) {
      case 1:
        return 1;
      default:
        return 1;
    }
  };
  export default getCozyGameIdByGameTokenId